// src/serviceWorkerRegistration.ts

// Este archivo registra el service worker para habilitar PWA y soporte offline.
// Basado en la configuración de Create React App.

const isLocalhost = Boolean(
    window.location.hostname === "localhost" ||
    // [::1] es localhost en IPv6
    window.location.hostname === "[::1]" ||
    // 127.0.0.0/8 son localhost IPv4
    window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/
    )
);

export function register(config?: { onUpdate?: (reg: ServiceWorkerRegistration) => void; onSuccess?: (reg: ServiceWorkerRegistration) => void }) {
    if ("serviceWorker" in navigator) {
        const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
        if (publicUrl.origin !== window.location.origin) {
            // El service worker no funcionará si PUBLIC_URL está en otro dominio
            return;
        }

        window.addEventListener("load", () => {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
            if (isLocalhost) {
                // En localhost, verifica si el service worker existe
                checkValidServiceWorker(swUrl, config);
                navigator.serviceWorker.ready.then(() => {
                    console.log("Service worker activo en modo localhost.");
                });
            } else {
                // En producción, registra directamente
                registerValidSW(swUrl, config);
            }
        });
    }
}

function registerValidSW(swUrl: string, config?: { onUpdate?: (reg: ServiceWorkerRegistration) => void; onSuccess?: (reg: ServiceWorkerRegistration) => void }) {
    navigator.serviceWorker
        .register(swUrl)
        .then(registration => {
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                if (installingWorker == null) return;

                installingWorker.onstatechange = () => {
                    if (installingWorker.state === "installed") {
                        if (navigator.serviceWorker.controller) {
                            // Nuevo contenido disponible
                            console.log("Nuevo contenido disponible; refresca la página.");
                            if (config && config.onUpdate) {
                                config.onUpdate(registration);
                            }
                        } else {
                            // Contenido cacheado para uso offline
                            console.log("Contenido cacheado para uso offline.");
                            if (config && config.onSuccess) {
                                config.onSuccess(registration);
                            }
                        }
                    }
                };
            };
        })
        .catch(error => {
            console.error("Error al registrar el service worker:", error);
        });
}

function checkValidServiceWorker(swUrl: string, config?: { onUpdate?: (reg: ServiceWorkerRegistration) => void; onSuccess?: (reg: ServiceWorkerRegistration) => void }) {
    fetch(swUrl, { headers: { "Service-Worker": "script" } })
        .then(response => {
            const contentType = response.headers.get("content-type");
            if (response.status === 404 || (contentType != null && contentType.indexOf("javascript") === -1)) {
                // No existe un service worker → recarga
                navigator.serviceWorker.ready.then(registration => {
                    registration.unregister().then(() => {
                        console.log("Service worker registrado.");
                        window.location.reload();
                    });
                });
            } else {
                // Service worker válido
                registerValidSW(swUrl, config);
            }
        })
        .catch(() => {
            console.log("Sin conexión a Internet. App funcionando en modo offline.");
        }).finally( () => {
            console.log("fin logica service worker.");
        } );
}

export function unregister() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready.then(registration => {
            registration.unregister();
        });
    }
}